import React from 'react';
import { getApi } from '../../api/endpoints.js';
import uiManager from '../../../config/ui.js';
import ListingComponent from '../../components/ListingComponent.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import UiAction from '../../components/UiAction.js';
import UI_ACTIONS from '../../data/UiActionConstants.js';
import { useNavigate, useParams } from 'react-router-dom';

const Listing = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const params = useParams();
  const navigate = useNavigate();

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'nomenclature_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      attr: 'name',
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile Number',
      attr: 'mobile_number',
    },
    {
      ...defaultHeaderConfig,
      label: 'Employee Id',
      attr: 'employee_id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Category',
      attr: 'category',
    },
    {
      ...defaultHeaderConfig,
      label: 'Created At',
      attr: 'created_at',
    },
    {
      ...defaultHeaderConfig,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.update_coordinator.name)}>
            <div style={{cursor: 'pointer'}} onClick={(e) => onEditClick(row.id)}>
              <FontAwesomeIcon icon={faEdit} />
            </div>
          </UiAction>
        </div>
      }
    },
  ]

  const onNewClick = () => {
    navigate(`/service_centers/${params.id}/dsc_coordinator/new`);
  }

  const onEditClick = (id) => {
    navigate(`/service_centers/${params.id}/dsc_coordinator/${id}/edit`);
  }

  const tableHeaderActionsComponent = () => {
    return <React.Fragment>
      <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.create_coordinator.name)}>
        <button className="s-btn me-2" style={{ width: "150px" }} onClick={onNewClick}>
          <span>Add New Coordinator</span>
        </button>
      </UiAction>
    </React.Fragment>
  }

  return <ListingComponent
    key={"Listing tab of dsc coordinator"}
    contentHeading="Coordinators List - Results"
    tableHeaderActionsComponent={tableHeaderActionsComponent()}
    listingMutation={getApi('dsc_coordinators')}
    className="dsc_coordinators_tab"
    headers={headers}
    recordsKey="dsc_coordinators"
    params= {props.defaultParams}
    search={["Coordinator Id", "Mobile Number"]}
  />
};

export default Listing;
